import { RJSFSchema, UiSchema } from "@rjsf/utils";
import { customizeValidator } from "@rjsf/validator-ajv8";
import JSONSchemaForm from "@rjsf/core";
import { useTranslation } from "react-i18next";
import { useContext, useEffect, useState } from "react";
import customFormats from "@beeldit/core/custom-validations/custom-validation";
import useProcessSchema from "@beeldit/core/hooks/useProcessSchema";
import widgets from "@beeldit/core/widgets/widgets";
import MultidimensionalCustomFormTemplate from "@beeldit/core/templates/MultidimensionalCustomFormTemplate";

interface Prop {
  formConfig: {
    formRef: any;
    onSubmit: any;
    context: any;
    action: string;
    className?: string;
    formDefaultValues?: any;
  };
}

interface Context {
  element: any;
  setElement: (element: any) => any;
  backendFormErrors: any;
}

function SuperOrderBillingAddressForm(props: Prop) {
  const { formRef, onSubmit, context, action, className, formDefaultValues } =
    props.formConfig;
  const { element, setElement, backendFormErrors } =
    useContext<Context>(context);

  const { t } = useTranslation();

  const [finalSchema, setFinalSchema] = useState<RJSFSchema>({});
  const translations = {
    observations: t("observations"),
  };

  let schema: any = {
    type: "object",
    properties: {
      billing_address: {
        type: "object",
        properties: {
          fiscal_name: {
            type: ["string", "null"],
            title: t("fiscal_name"),
          },
          fiscal_first_surname: {
            type: ["string", "null"],
            title: t("fiscal_first_surname"),
          },
          fiscal_address: {
            type: ["string", "null"],
            title: t("fiscal_address"),
          },
          fiscal_city: {
            type: ["string", "null"],
            title: t("fiscal_city"),
          },
          fiscal_zip: {
            type: ["string", "null"],
            title: t("fiscal_zip"),
          },
          fiscal_province: {
            type: ["string", "null"],
            title: t("fiscal_province"),
          },
          fiscal_country_code: {
            type: ["string", "null"],
            title: t("fiscal_country_code"),
            oneOf: [
              {
                const: "ES",
                title: "España",
              },
              {
                const: "PT",
                title: "Portugal",
              },
            ]
          },
          
        },
      },
    },
  };

  const uiSchema = {
    "ui:classNames": className,
    "ui:submitButtonOptions": {
      props: {
        disabled: false,
        className: "btn btn-info",
      },
      norender: true,
    },
    billing_address: {
      fiscal_country_code: {
        "ui:placeholder": "Selecciona un país",
      },
      colsSchema: [
        {
          cols: "col-12",
          elements: [
            [
              {
                name: "fiscal_name",
                cols: "col-6",
              },
              {
                name: "fiscal_first_surname",
                cols: "col-6",
              },
              {
                name: "fiscal_address",
                cols: "col-6",
              },
              {
                name: "fiscal_city",
                cols: "col-6",
              },
              {
                name: "fiscal_zip",
                cols: "col-6",
              },
              {
                name: "fiscal_province",
                cols: "col-6",
              },
              {
                name: "fiscal_country_code",
                cols: "col-6",
              },
            ],
          ],
        },
      ],
    },
  };
  const customWidgets = {
    ...widgets,
  };
  const handleChange = (type: any) => {
    /** Este método de momento es necesario aunque en realidad no tenga sentido, pero se debe a un bug de la libreria */
    // Actualizar el estado solo si no hay errores de validación
    setElement(type.formData);
    return console.log.bind(console, type);
  };
  const log = (type: any) => {
    return console.log.bind(console, type);
  };

  const formats = customFormats;
  const validator = customizeValidator({ customFormats: formats });

  const processSchemaFunction = useProcessSchema();

  useEffect(() => {
    setFinalSchema(processSchemaFunction(schema, element));
  }, [element]);

  const formTemplate = MultidimensionalCustomFormTemplate;

  return (
    <>
      <JSONSchemaForm
        noHtml5Validate
        showErrorList={false}
        ref={formRef}
        schema={finalSchema}
        uiSchema={uiSchema}
        widgets={customWidgets}
        formData={element}
        validator={validator}
        onChange={handleChange}
        onSubmit={onSubmit}
        onError={log("errors")}
        extraErrors={backendFormErrors}
        templates={{
          ObjectFieldTemplate: formTemplate,
        }}
      />
    </>
  );
}

export default SuperOrderBillingAddressForm;
